import { Button, styled } from '@mui/material';

export const LocationGroupBackButton = styled(Button)`
  margin: 0 8px;
  margin-bottom: 1px;
  padding: 15px 12px;
  width: calc(100% - 16px);
  height: 56px;
  justify-content: flex-start;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.5%;
  color: black;
  border-radius: 4px;

  .MuiButton-startIcon {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 0;
    margin-right: 15px;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    color: white;
    background: ${({ theme }) => theme.palette.primary.main};
  }
`;
